import styled from '@emotion/styled';

import { Box } from '@mui/material';
import { InputField } from '../../common/InputField/InputField';
import { BlackButton, OnlyTextButton } from '../../styledComponent/Buttons.style';
import { getColor } from '../../common/UICommon';

export const CouponWrapped = styled(Box)`
  margin-bottom: 32px;
`;
export const ShowCouponInputField = styled(OnlyTextButton)`
  margin-bottom: 8px;
  font-weight: 500;
  color: ${getColor('PURPLE_60')};
`;
export const InputRow = styled.div`
  display: flex;
`;
export const CouponInputWrapper = styled.div`
  margin-right: 8px;
  width: 100%;
`;

export const CouponInput = styled(InputField)``;

export const ApplyButton = styled(BlackButton)`
  max-width: 105px;
`;

export const AppliedCupponTag = styled.div`
  display: inline-flex;
  border-radius: 4px;
  background-color: ${getColor('DARK_CREAM')};
  padding: 12px;
  gap: 8px;
  align-items: center;
`;

export const AppliedCupponTagIcon = styled.img``;

export const AppliedCupponTagText = styled.span`
  font-weight: 16px;
  color: ${getColor('GRAY_80')};
`;

export const AppliedCupponTagDeleteIcon = styled.img`
  cursor: pointer;
`;
